/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signinasadmin3Inputs */

const en_signinasadmin3 = /** @type {(inputs: Signinasadmin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in as Admin`)
};

const de_signinasadmin3 = /** @type {(inputs: Signinasadmin3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Admin anmelden`)
};

/**
* | output |
* | --- |
* | "Sign in as Admin" |
*
* @param {Signinasadmin3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signinasadmin3 = /** @type {((inputs?: Signinasadmin3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signinasadmin3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signinasadmin3(inputs)
	return de_signinasadmin3(inputs)
});
export { signinasadmin3 as "signInAsAdmin" }